import Vue from 'vue';
import '@/assets/stylesheets/v2/_image-thumbnail.scss';
export default Vue.extend({
    props: {
        imageUrl: {
            type: String,
            required: true,
        },
        height: {
            type: String,
            default: '184',
        },
        width: {
            type: String,
            default: '184',
        },
    },
    render(createElement) {
        const self = this;
        return createElement('v-img', {
            class: 'image-thumbnail',
            props: {
                aspectRatio: '1',
                height: self.height,
                lazyUrl: self.imageUrl,
                src: self.imageUrl,
                width: self.width,
            },
        }, [
            createElement('v-layout', {
                class: 'align-center justify-center fill-height ma-0',
                slot: 'placeholder',
            }, [
                createElement('v-progress-circular', {
                    props: {
                        indeterminate: true,
                        color: 'grey lighten-2',
                    },
                }),
            ]),
        ]);
    },
});
